import { Browser } from "@capacitor/browser";
import { Link } from "@mui/material";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { SupportArticles, type SupportContext } from "@src/appV2/support/constants";

import { useSupportLinks } from "./hooks/useSupportLinks";

export interface HowToContactSupportLinkProps {
  supportContext: SupportContext;
}

/**
 * @deprecated Use ContactSupportButton for redesign instead. See src/appV2/support/ContactSupportButton.tsx
 */
export function HowToContactSupportLink(props: HowToContactSupportLinkProps) {
  const { supportContext } = props;

  const { howToContactSupportLink } = useSupportLinks();

  return (
    <Link
      onClick={async () => {
        await Browser.open({
          url: howToContactSupportLink,
          windowName: "_blank",
          presentationStyle: "popover",
        });
        logEvent(APP_V2_USER_EVENTS.OPENED_SUPPORT_ARTICLE, {
          articleLink: howToContactSupportLink,
          articleName: SupportArticles.HOW_TO_CONTACT_SUPPORT,
          supportContext,
        });
      }}
    >
      Contact Our 24/7 Support Team
    </Link>
  );
}
